export const mapSurveyNamesListFromApiModel = response => {
  const {
    data,
    meta: { count },
  } = response;

  return {
    names: data.map(({ id, attributes: { name } }) => ({ id, name })),
    count,
  };
};
